import React from 'react';
import styled from 'styled-components';

const FooterSection = styled.footer`
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 20px;
`;

function Footer() {
  const [subscribeMessage, setSubscribeMessage] = React.useState("");
  const [emailAddress, setEmailAddress] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const subscribe = async () => {
    if (!emailAddress) return;
    setLoading(true);
    setSubscribeMessage("");
    try {
      await fetch(`${process.env.REACT_APP_API_URL}?email=${emailAddress}`);
      setEmailAddress("");
      setSubscribeMessage(
        "Thanks for subscribing! You'll be the first to know about new features, templates, and updates."
      );
    } catch (error) {
      setSubscribeMessage(
        "Error: We weren't able to process your subscription. Please check your information and try again."
      );
      console.error("Subscription Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <section style={{ backgroundColor: "#F2F5FC" }} className="row p-4">
        <div className="col-md-6 mb-3">
          <h6 className="text-uppercase fw-bold mb-4">Stay Updated</h6>
          <span>Get updates on new features, templates, and improvements.</span>
          <div className="input-group">
            <input
              type="email"
              style={{ height: "40px" }}
              value={emailAddress}
              onChange={(e) => setEmailAddress(e.target.value)}
              className="form-control mb-3"
              placeholder="Email Address"
            />
            <button
              onClick={subscribe}
              disabled={loading}
              style={{ marginLeft: "8px", height: "40px" }}
            >
              {loading ? "Submitting..." : "Get Updates"}
            </button>
          </div>
          {subscribeMessage && (
            <p
              style={{
                color: subscribeMessage.toLowerCase().includes("error")
                  ? "red"
                  : "green",
                fontSize: "10px",
              }}
            >
              {subscribeMessage}
            </p>
          )}
        </div>
        <div className="col-md-6 align-content-center">
          <h6 className="text-uppercase fw-bold mb-4">Quick Links</h6>
          <a href="/coupons">Coupons</a> | <a href="/invoices">Professional Invoices</a> | <a href="/landingPages">Landing Pages</a>
        </div>
      </section>
      <FooterSection>
        <p>&copy; {new Date().getFullYear()} Wendaspace. All rights reserved.</p>
      </FooterSection>
    </div>
  );
}

export default Footer;
